import { useState } from "react";
import PrimaryButton from "../components/PrimaryButton";
import { BackLink, CardSubtitle, CardTitle } from "../components/AuthCard";
import { WhatsAppIcon } from "../components/Icons";
import { CHANNELS } from "../constants";

const OPTIONS = [
  {
    value: CHANNELS.WHATSAPP,
    title: "WhatsApp",
    subtitle: (mobile) => `Message on WhatsApp to ${mobile}`,
    icon: <WhatsAppIcon />,
    iconClass: "bg-[#24D366] text-white",
  },
];

// A4 / B2 — same screen for both flows; WhatsApp only for now, pre-selected
const ChooseChannel = ({ header, maskedMobile, onSend, onBack }) => {
  const [channel, setChannel] = useState(CHANNELS.WHATSAPP);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    await onSend(channel);
    setLoading(false);
  };

  return (
    <>
      {header}
      <CardTitle className="mt-[3px]">Secure your account</CardTitle>
      <CardSubtitle>
        We&apos;ll send a one-time password (OTP) to your registered mobile
        number{" "}
        <span className="font-geomanistBold text-blackShade">{maskedMobile}</span>
      </CardSubtitle>

      <div className="flex flex-col gap-3 mt-5" role="radiogroup">
        {OPTIONS.map((option) => {
          const selected = channel === option.value;
          return (
            <label
              key={option.value}
              className={`flex items-center gap-3 rounded-xl border-[1.5px] px-4 py-3 cursor-pointer transition-colors mb-0
                ${selected ? "border-[#1F4FC6] bg-[#F5F7FF]" : "border-[#E1E5EB] hover:border-[#C5C8D0]"}`}
            >
              <input
                type="radio"
                name="otp-channel"
                value={option.value}
                checked={selected}
                onChange={() => setChannel(option.value)}
                className="appearance-none w-4 h-4 shrink-0 rounded-full border-[1.5px] border-[#B8BFCB] bg-white cursor-pointer checked:border-[#1F4FC6] checked:bg-[#1F4FC6] checked:[background-image:radial-gradient(circle,#fff_0,#fff_2.5px,transparent_3px)]"
              />
              <span
                className={`w-7 h-7 rounded-full flex items-center justify-center shrink-0 ${option.iconClass}`}
              >
                {option.icon}
              </span>
              <span className="flex flex-col">
                <span className="flex items-center gap-2 font-geomanistMedium text-sm leading-5 text-blackShade">
                  {option.title}
                </span>
                <span className="font-geomanistRegular text-xs leading-4 text-geomanistgray">
                  {option.subtitle(maskedMobile)}
                </span>
              </span>
            </label>
          );
        })}
      </div>

      <div className="mt-6">
        <PrimaryButton
          title="Send OTP"
          onClick={handleSend}
          loading={loading}
          disabled={!channel || loading}
        />
      </div>

      <BackLink label="Back to login" onClick={onBack} />
    </>
  );
};

export default ChooseChannel;
